import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectConfigurationService } from '../global_services/project_config.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  clientId: string;
  loaded;
  error;
  PROJECT_NAME;


  configData;
  constructor(@Inject('PROJECT_NAME') PROJECT_NAME, private projectConfigurationService: ProjectConfigurationService, private route: ActivatedRoute, private router: Router) {

    this.PROJECT_NAME = PROJECT_NAME;
/*     this.route.queryParams.subscribe(params => {
      this.clientId = params["client"]  || this.PROJECT_NAME  ;    
    }); */

    this.clientId = this.route.snapshot.paramMap.get('client') || this.PROJECT_NAME  ;

    this.projectConfigurationService.clientId = 'QUIZZAI' //this.clientId;

   // console.log("Welcome Component Init", this.clientId);

    this.projectConfigurationService.getConfigData(this.clientId).subscribe(res => {

      console.log("searching for customer", this.clientId);

      if (res) {
        this.configData = res.instance_name;
        //console.log("found",res);

/*                 if(this.projectConfigurationService.currentConfigData.showLandingPage==true){
        
                   this.router.navigate([ "/" + (this.projectConfigurationService.currentConfigData.instance_name) + "/login"] ) ;
        
                }else{
                  this.router.navigate([ "/" + (this.projectConfigurationService.currentConfigData.instance_name ) + "/start-screen"]);
        
                }  */


        // this.router.navigate([ "/" + (this.projectConfigurationService.currentConfigData.instance_name ) + "/start-screen"]);

      } else {

        console.log("Could not find customer");

      }
      this.loaded = true;
    }, err => {
      this.error = err;
      console.log("Configuration error", err)

    })
  }

  ngOnInit() {



  }

}